import React from "react";
import ServiceTrackPage from "./ServiceTrackPage";

const automationPhases = [
  {
    step: "01",
    title: "Workflow Baseline",
    detail:
      "We map bottlenecks, handoff gaps, and failure points to identify where automation drives measurable lift first.",
  },
  {
    step: "02",
    title: "System & Control Design",
    detail:
      "We define orchestration logic, escalation paths, approvals, and integration boundaries before implementation starts.",
  },
  {
    step: "03",
    title: "Build & Production Pilot",
    detail:
      "We ship automated workflows across your stack with observability, fallback logic, and run-time controls.",
  },
  {
    step: "04",
    title: "Scale & Optimization",
    detail:
      "We expand proven flows across teams, optimize performance, and continuously improve SLA and quality outcomes.",
  },
];

const AutomationPage = () => {
  return (
    <ServiceTrackPage
      trackLabel="Automation Track"
      title="Automation That Runs Core Operations"
      accentLine="From manual handoffs to always-on execution."
      description="We redesign repetitive operations into reliable, agentic workflows. You get faster throughput, tighter quality control, and a clear operating model your team can scale."
      topPrimaryCtaLabel="Book an Automation Session"
      topSecondaryCtaLabel="See Execution Model"
      engagementId="automation-delivery"
      outcomesHeading="What You Walk Away With"
      outcomes={[
        "Prioritized automation blueprint across high-friction workflows",
        "Human-in-the-loop control design for approvals and exceptions",
        "Integration architecture across CRM, helpdesk, and internal systems",
        "Operating metrics for cycle time, quality, and cost-to-serve",
      ]}
      metricsHeading="Expected Outcomes"
      metrics={[
        { value: "35-70%", label: "manual effort reduced" },
        { value: "2-4x", label: "faster workflow throughput" },
        { value: "4-8", label: "weeks to first live lane" },
        { value: "24/7", label: "operational continuity" },
      ]}
      phases={automationPhases}
      finalEyebrow="Final Step"
      finalTitleLine="Pick one workflow to automate first."
      finalAccentLine="We’ll help you ship it into production."
      finalDescription="Start with a focused automation sprint and convert one high-impact process into a measurable production win."
      finalCtaLabel="Book a Free Audit"
    />
  );
};

export default AutomationPage;
